import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './configureStore';

export interface TournamentState {
    computer: number;
    playerName: string;
    tournamentSessionID: number;
    initiated: boolean;
}
const initialState: TournamentState = {
    playerName: '',
    computer: -1,
    tournamentSessionID: -1,
    initiated: false,
};

export const tournamentSlice = createSlice({
    name: 'tournamentSlice',
    initialState,
    reducers: {
        setInitiated: (state, action: PayloadAction<boolean>) => {
            state.initiated = action.payload;
        },
        setPlayer: (state, action: PayloadAction<string>) => {
            state.playerName = action.payload;
        },
        setComputer: (state, action: PayloadAction<number>) => {
            state.computer = action.payload;
        },
        setTournamentSessionID: (state, action: PayloadAction<number>) => {
            state.tournamentSessionID = action.payload;
        },
        reset: (state) => {
            state.playerName = '';
            state.computer = -1;
            state.tournamentSessionID = -1;
            state.initiated = false;
        },
    },
});

export const selectState = (state: RootState) => state.tournamentSlice;
export const selectPlayer = createSelector(selectState, (state) => state.playerName);
export const selectComputer = createSelector(selectState, (state) => state.computer);
export const selectTournamentSessionID = createSelector(selectState, (state) => state.tournamentSessionID);
export const selectInitiated = createSelector(selectState, (state) => state.initiated);

export const { setInitiated, setPlayer, setComputer, setTournamentSessionID, reset } = tournamentSlice.actions;
